import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesExplicitFieldAssociationRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-explicit-field-association-project-list',
	path: '/jira/settings/issues/explicit-field-association',
};
